import { createStackNavigator } from '@react-navigation/stack'

import { SearchStackParamList } from './types'

export const SearchStack = createStackNavigator<SearchStackParamList>()
